import { render, staticRenderFns } from "./_Address.vue?vue&type=template&id=6948af0a&"
import script from "./_Address.vue?vue&type=script&lang=ts&"
export * from "./_Address.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports